module.exports = __webpack_public_path__ + "media/open_box41.8dd1349e.mp3";